import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  CircularProgress,
  Container,
  TextField,
  Typography,
} from "@mui/material";
import { fetchData, postData } from "../../../Api";
import {
  getCategories,
  getDistrict,
  getGenders,
  getMyProfile,
  getSubjects,
} from "../../../Functon/function";
import Swal from "sweetalert2";
import Acr from "./Acr";
import {
  MdDetails,
  MdLocationOn,
  MdPerson2,
  MdWorkHistory,
  MdWorkspacesFilled,
} from "react-icons/md";

const defaultFormData = {
  name: "",
  fsName: "",
  dob: "1990-01-01",
  doj: "1990-01-01",
  firstSchoolName: "",
  lastSchoolName: "",
  dor: "1990 Enlargement-01",
  lastSalary: "",
  subject: "",
  mobile: "",
  email: "",
  panNo: "",
  aadharNo: "",
  pAddress1: "",
  pAddress2: "",
  pBlock: "",
  pDistrictId: "",
  pPincode: "",
  cAddress1: "",
  cAddress2: "",
  cBlock: "",
  cDistrictId: "",
  cPincode: "",
  entrydate: "1990-01-01",
  entryBy: 0,
  member: 0,
  panAttachment: "",
  aadharAttachment: "",
  profileImage: "",
  gender: "",
  category: "",
  categoryAttachment: "",
  aDistrictId: "",
  applyPost: "",
  retiredPost: "",
  retiredDept: "",
  fixedPension: "",
  gettingPension: "",
  grade: Array(9).fill(null),
  handicap: "No",
  freedom: "No",
  treasuryname: "",
  ppono: "",
};

const Profile = () => {
  const [personalData, setPersonalData] = useState(defaultFormData);
  const [districts, setDistricts] = useState([]);
  const [gender, setGender] = useState([]);
  const [category, setCategory] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gradepara, setGradepara] = useState([]);

  useEffect(() => {
    fetchMasterData();
  }, []);

  const fetchMasterData = async () => {
    setLoading(true);
    try {
      const [dres, gres, sres, cres, gradeRes, profileData] = await Promise.all([
        getDistrict(),
        getGenders(),
        getSubjects(),
        getCategories(),
        fetchData("Master/gradepara"),
        getMyProfile(),
      ]);

      setDistricts(dres);
      setGender(gres);
      setSubjects(sres);
      setCategory(cres);
      setGradepara(gradeRes);

      if (profileData) {
        setPersonalData({ ...profileData.member, grade: profileData.grade });
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPersonalData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAutocompleteChange = (name, value) => {
    setPersonalData((prev) => ({ ...prev, [name]: value }));
  };

  const handleGradeChange = (index, value) => {
    setPersonalData((prev) => {
      const updatedGrade = [...(prev.grade || Array(9).fill(null))];
      updatedGrade[index] = value;
      return { ...prev, grade: updatedGrade };
    });
  };

  const handleSubmit = async (e) => {
    console.log(personalData);
    e.preventDefault();
    setLoading(true);
    try {
      const res = await postData("Activity/newprofile", personalData);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: res,
      }).then(() => {
        window.location.href = "/pan";
      });
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: e.details,
      });
    }
    setLoading(false);
  };

  const renderAutocomplete = ({
    label,
    name,
    options,
    value,
    require,
    onChange,
    index,
    multiple = false,
  }) => (
    <Container maxWidth="xs" className="mt-4">
      <Autocomplete
        multiple={multiple}
        options={options}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            name={name}
            variant="outlined"
            color="success"
            type="text"
            required = {require ? false : true}
            fullWidth
          />
        )}
        onChange={(e, newValue) =>
          onChange(multiple ? newValue.join(", ") : newValue)
        }
        value={multiple ? (value ? value.split(", ") : []) : value}
        getOptionLabel={(option) =>
          typeof option === "object" ? option.label || "" : option || ""
        }
        isOptionEqualToValue={(option, val) =>
          typeof option === "object" ? option.value === val?.value : option === val
        }
      />
    </Container>
  );

  const renderGradeAutocomplete = ({ label, name, dataKey, index }) => {
    const options = gradepara[dataKey]?.map((item) => ({
      label: item.name,
      value: item.id,
    })) || [];
    const currentValue =
      options.find((opt) => opt.value === personalData.grade?.[index]) || null;

    return (
      <Container maxWidth="xs" className="mt-4">
        <Autocomplete
          options={options}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              name={name}
              variant="outlined"
              color="success"
              type="text"
              required
              fullWidth
            />
          )}
          onChange={(e, newValue) => handleGradeChange(index, newValue?.value || null)}
          value={currentValue}
          getOptionLabel={(option) => option.label || ""}
          isOptionEqualToValue={(option, value) => option.value === value?.value}
        />
      </Container>
    );
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center w-full h-screen">
        <CircularProgress size="4rem" />
      </div>
    );
  }

  return (
    <div className="items-center p-2">
      <Typography className="text-center" fontWeight={700} fontSize={32}>
        Your Profile
      </Typography>

      {gradepara && (
        <form onSubmit={handleSubmit}>
        
          {/* Applied Job Section */}
          <SectionHeader icon={<MdWorkspacesFilled />} title="Applied Job" />
          <div className="grid md:grid-cols-3 grid-cols-1">
            {renderAutocomplete({
              label: "District (Location)",
              name: "aDistrictId",
              options: districts.map((d) => d.name),
              value: districts.find((d) => d.id === personalData.aDistrictId)?.name || "",
              onChange: (value) =>
                handleAutocompleteChange(
                  "aDistrictId",
                  districts.find((d) => d.name === value)?.id || ""
                ),
            })}
            {renderAutocomplete({
              label: "Post (Applied For)",
              name: "applyPost",
              options: gradepara.apply_post?.map((p) => p.name) || [],
              value:
                gradepara.apply_post?.find((p) => p.id === personalData.applyPost)?.name ||
                "",
              onChange: (value) =>
                handleAutocompleteChange(
                  "applyPost",
                  gradepara.apply_post?.find((p) => p.name === value)?.id || ""
                ),
            })}
            {renderGradeAutocomplete({
              label: "Age at Contract",
              name: "ageAtContract",
              dataKey: "age_at_contract",
              index: 0,
            })}
          </div>

          {/* Personal Details Section */}
          <SectionHeader icon={<MdPerson2 />} title="Personal Details" />
          <div className="grid md:grid-cols-3 grid-cols-1">
            <TextFieldContainer
              label="Name as on Service Book"
              name="name"
              value={personalData.name}
              onChange={handleInputChange}
            />
            <TextFieldContainer
              label="Father's / Spouse Name"
              name="fsName"
              value={personalData.fsName}
              onChange={handleInputChange}
            />
            {renderAutocomplete({
              label: "Gender",
              name: "gender",
              options: gender,
              value: personalData.gender,
              onChange: (value) => handleAutocompleteChange("gender", value),
            })}
            {renderAutocomplete({
              label: "Category",
              name: "category",
              options: category.map((c) => c.cname),
              value: personalData.category,
              onChange: (value) => handleAutocompleteChange("category", value),
            })}
            <TextFieldContainer
              label="Date of Birth"
              name="dob"
              type="date"
              value={personalData.dob}
              onChange={handleInputChange}
            />
            <TextFieldContainer
              label="Mobile (+91)"
              name="mobile"
              type="number"
              value={personalData.mobile}
              onChange={handleInputChange}
              inputProps={{ maxLength: 10 }}
            />
            <TextFieldContainer
              label="Email"
              name="email"
              type="email"
              value={personalData.email}
              onChange={handleInputChange}
            />
            <TextFieldContainer
              label="AADHAR No."
              name="aadharNo"
              type="number"
              value={personalData.aadharNo}
              onChange={handleInputChange}
              inputProps={{ maxLength: 12 }}
            />
            {renderAutocomplete({
              label: "Handicapped (Yes, Required certificate)",
              name: "handicap",
              options: ["No", "Yes"],
              value: personalData.handicap ,
              onChange: (value) =>
                handleAutocompleteChange("handicap", value),
            })}
            {renderAutocomplete({
              label: "Dependents of freedom fighters (Yes, Required certificate)",
              name: "freedom",
              options: ["No", "Yes"],
              value: personalData.freedom ,
              onChange: (value) =>
                handleAutocompleteChange("freedom", value),
            })}
          </div>

          {/* Address Section */}
          <SectionHeader icon={<MdLocationOn />} title="Address" />
          <div className="grid md:grid-cols-3 grid-cols-1">
            <TextFieldContainer
              label="Address 1"
              name="pAddress1"
              value={personalData.pAddress1}
              onChange={handleInputChange}
            />
            <TextFieldContainer
              label="Address 2"
              name="pAddress2"
              value={personalData.pAddress2}
              onChange={handleInputChange}
            />
            <TextFieldContainer
              label="Block"
              name="pBlock"
              value={personalData.pBlock}
              onChange={handleInputChange}
            />
            {renderAutocomplete({
              label: "District",
              name: "pDistrictId",
              options: districts.map((d) => d.name),
              value: districts.find((d) => d.id === personalData.pDistrictId)?.name || "",
              onChange: (value) =>
                handleAutocompleteChange(
                  "pDistrictId",
                  districts.find((d) => d.name === value)?.id || ""
                ),
            })}
            <TextFieldContainer
              label="Area Pin Code / ZIP Code"
              name="pPincode"
              type="number"
              value={personalData.pPincode}
              onChange={handleInputChange}
            />
          </div>

          {/* Job Details Section */}
          <SectionHeader icon={<MdWorkspacesFilled />} title="Job Details" />
          <div className="grid md:grid-cols-3 grid-cols-1">
            <TextFieldContainer
              label="First Joined School Name"
              name="firstSchoolName"
              value={personalData.firstSchoolName}
              onChange={handleInputChange}
            />
            <TextFieldContainer
              label="Date of Joining"
              name="doj"
              type="date"
              value={personalData.doj}
              onChange={handleInputChange}
            />
            <TextFieldContainer
              label="Last Joined School Name"
              name="lastSchoolName"
              value={personalData.lastSchoolName}
              onChange={handleInputChange}
            />
            <TextFieldContainer
              label="Date of Retirement"
              name="dor"
              type="date"
              value={personalData.dor}
              onChange={handleInputChange}
            />
            <TextFieldContainer
              label="Last Basic Salary"
              name="lastSalary"
              value={personalData.lastSalary}
              onChange={handleInputChange}
            />
            {renderAutocomplete({
              label: "Subject Specialization",
              name: "subject",
              require : 'no',
              options: subjects.map((s) => s.sname),
              value: personalData.subject,
              onChange: (value) => handleAutocompleteChange("subject", value),
              multiple: true,
            })}
            {renderAutocomplete({
              label: "Retired from (Post)",
              name: "retiredPost",
              options: gradepara.retired_post?.map((p) => p.name) || [],
              value:
                gradepara.retired_post?.find((p) => p.id === personalData.retiredPost)
                  ?.name || "",
              onChange: (value) =>
                handleAutocompleteChange(
                  "retiredPost",
                  gradepara.retired_post?.find((p) => p.name === value)?.id || ""
                ),
            })}
            {renderAutocomplete({
              label: "Retired from (Department)",
              name: "retiredDept",
              options: gradepara.retired_dept?.map((d) => d.name) || [],
              value:
                gradepara.retired_dept?.find((d) => d.id === personalData.retiredDept)
                  ?.name || "",
              onChange: (value) =>
                handleAutocompleteChange(
                  "retiredDept",
                  gradepara.retired_dept?.find((d) => d.name === value)?.id || ""
                ),
            })}
            <TextFieldContainer
              label="Fixed Pension"
              name="fixedPension"
              type="number"
              value={personalData.fixedPension}
              onChange={handleInputChange}
            />
            <TextFieldContainer
              label="Current Pension"
              name="gettingPension"
              type="number"
              value={personalData.gettingPension}
              onChange={handleInputChange}
            />
            <TextFieldContainer
              label="Treasury from where pension is received"
              name="treasuryName"
              value={personalData.treasuryname}
              onChange={handleInputChange}
            />
            <TextFieldContainer
              label="PPO No"
              name="ppoNo"
              value={personalData.ppono}
              onChange={handleInputChange}
            />
          </div>

          {/* ACR Section */}
          {/* {personalData.grade && (
            <Acr
              gradepara={gradepara}
              setPersonalData={setPersonalData}
              personalData={personalData}
            />
          )} */}

   <SectionHeader icon={<MdWorkHistory />} title="Last Five Years Annual Confidential Report (ACR)" />

   <div className="grid md:grid-cols-3 grid-cols-1">
   {renderGradeAutocomplete({
              label: "Year 5",
              name: "gradeYear5",
              dataKey: "acr_5",
              index: 4,
            })}
            {renderGradeAutocomplete({
              label: "Year 4",
              name: "gradeYear4",
              dataKey: "acr_4",
              index: 5,
            })}
             {renderGradeAutocomplete({
              label: "Year 3",
              name: "gradeYear3",
              dataKey: "acr_3",
              index: 6,
            })}
            {renderGradeAutocomplete({
              label: "Year 2",
              name: "gradeYear2",
              dataKey: "acr_2",
              index: 7,
            })}
            {renderGradeAutocomplete({
              label: "Year 1",
              name: "gradeYear1",
              dataKey: "acr_1",
              index: 8,
            })}
   </div>
          {/* Work Experience Details Section */}
          <SectionHeader icon={<MdWorkHistory />} title="Work Experience Details" />
          <div className="grid md:grid-cols-3 grid-cols-1">
            {renderGradeAutocomplete({
              label: "Concern Department (Equivalent Position)",
              name: "wecd",
              dataKey: "w_exp_oncern_dept",
              index: 1,
            })}
            {renderGradeAutocomplete({
              label: "Other Department (Equivalent Position)",
              name: "wExpOtherDept",
              dataKey: "w_exp_oth_dept",
              index: 2,
            })}
            {renderGradeAutocomplete({
              label: "Same department after retirement (Equivalent Position)",
              name: "wExpSameDeptAfterRetire",
              dataKey: "w_exp_same_dept_after_retire",
              index: 3,
            })}
          </div>

          {/* Submit Button */}
          <div className="flex mt-8 justify-center items-center w-full">
            {personalData.pAddress1.length <= 10 ? (
              <p className="px-4 p-1 bg-gray-300 font-semibold text-red-600">
                Address 1 length is too short
              </p>
            ) : (
              <Button
                disabled={personalData.isapproved}
                variant="contained"
                type="submit"
                onClick={()=>console.log(personalData)}
              >
                Submit
              </Button>
            )}
          </div>
        </form>
      )}
    </div>
  );
};

// Helper Components
const SectionHeader = ({ icon, title }) => (
  <h1 className="text-2xl text-center w-full font-bold flex items-center mb-4 text-gray-800">
    <span className="flex items-center cursor-help mt-8">
      {React.cloneElement(icon, { className: "text-green-600 mr-2" })}
      {title}
    </span>
  </h1>
);

const TextFieldContainer = ({ label, name, value, onChange, type = "text", inputProps }) => (
  <Container maxWidth="xs" className="mt-4">
    <TextField
      fullWidth
      label={label}
      name={name}
      variant="outlined"
      color="success"
      type={type}
      value={value}
      onChange={onChange}
      required
      inputProps={inputProps}
    />
  </Container>
);

export default Profile;